import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Agencies } from "src/app/models/dmv/models";
import { PaymentDevice } from "src/app/models/user/paymentDevice";
import { DMVStoreService } from "src/app/services/dmv/dmv-store.service";
import { GlobalService } from "src/app/services/global/global.service";
import { MEGStoreService } from "src/app/services/meg/meg-store.service";
import { USERDataService } from "src/app/services/user/user-data.service";
import { USERStoreService } from "src/app/services/user/user-store.service";
import { AppUtil } from "src/app/utils/app.util";

@Component({
	selector: "app-payment-methods",
	templateUrl: "./payment-methods.component.html",
	styleUrls: ["./payment-methods.component.css"]
})
export class PaymentMethodsComponent implements OnInit, OnDestroy {
	constructor(
		public router: Router,
		public globalService: GlobalService,
		public userStoreService: USERStoreService,
		public dmvStoreService: DMVStoreService,
		public userDataService: USERDataService,
		public megStoreService: MEGStoreService,
		private cd: ChangeDetectorRef
	) {}
	public agencies: Agencies;
	public errorMessage: string = "";
	public isloading: boolean = false;
	public sucessMessage: string = "";
	ngOnInit() {
		this.megStoreService.configurationsData$.subscribe(data => {
			if (data && data.megConfig) {
				this.agencies = data.megConfig.agencies;
			}
		});
	}
	public close() {
		this.back();
	}
	public back() {
		this.router.navigate(["profile"], { skipLocationChange: true });
	}
	ngOnDestroy() {
		this.userStoreService.outComeText = "";
	}
	public getagencyById(id) {
		const _this = this;
		const agency = this.agencies.filter(function(item) {
			return item.agencyID.toString() === id.toString();
		});
		return agency[0].name;
	}
	public edit(paymentDevice: PaymentDevice) {
		this.userStoreService.paymentDevice = paymentDevice;
		this.userStoreService.outComeText = "";
		this.router.navigate(["edit-payment-method"], { skipLocationChange: true });
	}
	public delete(paymentDevice: PaymentDevice) {
		this.isloading = true;
		this.userStoreService.outComeText = "";
		this.userDataService
			.deletePaymentDeviceCall(
				this.dmvStoreService.sessionGUID,
				this.userStoreService.getUserProfile().megUserGUID,
				paymentDevice.fundingToken
			)
			.subscribe(
				response => {
					AppUtil.log("deletePaymentDeviceCall() ==>", response);
					if (response) {
						this.isloading = false;
						if (response.statusCode === 200) {
							this.sucessMessage = response.OutcomeText;
							const userProfile = this.userStoreService.getUserProfile();
							userProfile.paymentDevices.splice(
								userProfile.paymentDevices.findIndex(
									a => a.fundingToken === paymentDevice.fundingToken
								),
								1
							);
							this.userStoreService.setUserProfileFromResponse(
								response,
								userProfile
							);
						} else {
							this.errorMessage = response.OutcomeText;
							window.scrollTo(0, 0);
						}
						this.cd.detectChanges();
					}
				},
				error => {
					AppUtil.log("deletePaymentDeviceCall()==> error:", error);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.errorMessage =
							"Internal system error.  Please retry.  If this problem persists, please contact our support team for assistance.";

						this.isloading = false;
						window.scrollTo(0, 0);
						this.cd.markForCheck();
					}
				}
			);
	}
}
